<template>
	<div class='knd-filter'>
		<select class='select-css' v-model="selected" @change="onChange($event)">
			<option value="0" >Filter op onderwerp</option>
			<option 
				v-for="(thema, index) in themas" 
				:key="'header-thema' + index"
				:value="thema.id">
					{{thema.label}}
			</option>
		</select>
	</div>
</template>

<script>

	const vueObject = {
		data: function() {
			return {
				
			}
		},
		computed: {
			themas() { 
				return this.$store.state.data.themas;
			},

			selected() {
				return this.$store.getters.getSelectedThemeId;
			}
		},	

		mounted: function() {
		},

		methods: {
			onChange(evt) {
				let thema = this.$store.getters.getFilterById(+event.target.value);


				if(thema) {
					this.$store.dispatch('updateFilter', {thema});
					this.$router.push({ name: 'Articles', query: { filter: thema.id } });
				} else {
					this.$router.push({ name: 'Articles', query: { filter: undefined } });
					this.$store.dispatch('resetFilter');
				}

			},

			getThemaById(id) {
				let index = this.themas.findIndex(t => t.id === id);
				return this.themas[index];
			}
		}
	}

	export default vueObject;
</script>